import { LitElement, html, css } from 'lit';
import { accessibility } from '../../utilities/styles';
import { EventManager } from '../../utilities/events';
import { ContextConsumer } from '@lit/context';
import { organisationContext } from '../../utilities/context';
/* I think we only have 3 steps now actually.
@Kay Pang
 what do you think?
Set up first location
Set up first zone
Submit for approval */
export class AllInProgressGraph extends LitElement {
    static properties = {
        location: { type: String },
        locationAwaitingApproval: { type: String },
        zone: { type: String },
        zoneAwaitingApproval: { type: String },
        approval: { type: String },
    };
    constructor() {
        super();
    }
    connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        this._organisationData = new ContextConsumer(this, { context: organisationContext, subscribe: true });
        this.organisationData = this._organisationData?.value;
        ({ name: this.name } = this.organisationData);
    }
    render() {
        let percent = 0;
        let message = `Next step: Set up a location`;
        let progressStatement = `Set up a location`;
        if (this.approval == 'true') {
            percent = 33;
            if (this.locationAwaitingApproval == 'true') {
                progressStatement = `Await approval`;
                ;
                message = `Next step: Your location needs to be approved`;
            }
            else {
                progressStatement = `Your location listing isn't complete`;
                ;
                message = html `<a href="#" @click=${this._clickHandler}>Next step: Set up your location</a>`;
            }
        }
        if (this.location == 'true' && this.locationAwaitingApproval != 'true') {
            percent = 66;
            progressStatement = `Set up your zone`;
            message = `Next step: Set up your zone`;
            if (this.zone == 'true' && this.zoneAwaitingApproval == 'true') {
                progressStatement = `Await approval`;
                message = `Next step: Your zone needs to be approved`;
            }
        }
        if (this.zone == 'true' && this.zoneAwaitingApproval !== 'true') {
            return '';
        }
        return html `\n            <div class="graph">\n                <div class="pie percent_${percent}"><div class="pie_inner">${percent}%</div></div>\n                <div class="message">\n                    <p>${progressStatement}</p>\n                    ${message}</a>\n                </div>\n            </div>\n        `;
    }
    _clickHandler(e) {
        e.preventDefault();
        let details = {
            dashboard: 'locations',
        };
        if (this.location == 'true') {
            details.panel = 'zones';
        }
        this.eventManager.emit(`allin-organisation-${this.name}-switcher`, details);
    }
    static styles = [
        accessibility,
        css `
            .graph{
                display:flex;
                align-items:center;
                gap:3rem;
                margin:1.2rem;
            }
            .pie{
                position:relative;
                width:5rem;
                height:5rem;
                display:flex;
                align-items:center;
                justify-content:center;
            }

            .pie_inner{
                position:relative;
                width:5rem;
                height:5rem;
                border-radius:50%;
                color:var(--allin-highlight-color,#472961); 
                outline:0.5rem solid var(--bg-color,#f7f7f7);
                background-color:var(--allin-secondary-light,#D3C9D7);
                display:flex;
                justify-content:center;
                align-items:center;
                font-size:1.6rem;
                font-weight:700;
                z-index:10;
            }
            
            .pie::after,.pie::before{
                position:absolute;
                content:'';
                width:8rem;
                height:8rem;
                top:50%;
                left:50%;
                transform:translate(-50%,-50%);
                border-radius:50%;
                z-index:2;
            }
            .pie::before{
                background-color:var(--allin-secondary-light,#D3C9D7);
                z-index:1;
            }
            .percent_33::after{
                background-image: conic-gradient(#472961 0deg 120deg, transparent 120deg 360deg);
            }
            .percent_50::after{
                background-image: conic-gradient(#472961 0deg 180deg, transparent 180deg 360deg);
            }
            .percent_66::after{
                background-image: conic-gradient(#472961 0deg 240deg, transparent 240deg 360deg);
            }
            .percent_75::after{
                background-image: conic-gradient(#472961 0deg 270deg, transparent 270deg 360deg);
            }
            .message{
                font-size:1.2rem;
            }
            p{
                margin-bottom:0.5rem;
            }
            a{
               color:var(--allin-highlight-color,#472961); 
               font-weight:700;
               transition:text-decoration-thickness var(--transition) ease;
            }
            a:hover{
                text-decoration-thickness: 0.1em;
            }
        `
    ];
}
